import getGuid from './getGuid';
import log from './log';
import { LogLevel } from '../enums/Enum';
import GlobalVariables from '../GlobalVariables';
import Cookies from './Cookies';
import getCookieValue from './getCookieValue';
import fromQueryString from './fromQueryString';

const internalTrack = function (hitType, category, action, value) {
    if (window.ApexChatInternalTracking) {
        let tracker = getCookieValue('livechat_tracker_id');
        if (!tracker) {
            tracker = getGuid();
            Cookies.set('livechat_tracker_id', tracker, 365);
        }

        const img = new Image();
        const params = [];
        let vid = getCookieValue('livechat_visitor_id');
        if (!vid) {
            vid = fromQueryString('visitorId') || '';
        }
        let hid = getCookieValue('livechat_visitor_history');
        if (!hid) {
            hid = fromQueryString('guid') || '';
        }
        let cid = getCookieValue('livechat_chat_id');
        if (!cid) {
            cid = fromQueryString('chatId') || '';
        }
        const eid = getGuid();
        const pid = getCookieValue('livechat_profile_id') || '';
        const page = window.location.href.substring(0, 1000);
        let url = `//analytics.apexchat.net/track?companyKey=${ApexChatCompanyKey}&hitType=${hitType}&category=${encodeURIComponent(
            category
        )}&visitorId=${vid}&historyId=${hid}&profileId=${pid}&pageUrl=${encodeURIComponent(
            page
        )}&chatId=${cid}&trackerId=${encodeURIComponent(tracker)}&eId=${encodeURIComponent(
            eid
        )}`;
        if (action) {
            url += `&action=${encodeURIComponent(action)}`;
        }
        if (value || value === 0) {
            url += `&value=${encodeURIComponent(value)}`;
        }
        url += `&dt=${new Date().getTime()}`;
        img.src = url;
        log(`Tracking on aws: ${url}`, LogLevel.Debug);

        if (!GlobalVariables.alwaysTrackOnce) {
            GlobalVariables.alwaysTrackOnce = true;
            const url2 = `//stats.co/track?companyKey=${ApexChatCompanyKey}&hitType=event&action=997_TrackingLoaded&category=${encodeURIComponent(
                category
            )}&visitorId=${vid}&historyId=${hid}&profileId=${pid}&pageUrl=${encodeURIComponent(
                page
            )}&chatId=${cid}&trackerId=${encodeURIComponent(tracker)}`;
            const img2 = new Image();
            img2.src = url2;
        }
    }
};
export default internalTrack;
